import { useState } from "react";
import validate2fa from "../../helperFunctions/validate2fa";
import { Card, Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

export default function Login2FA() {
  const [validated, setValidated] = useState(false);
  const [tfaError, setTfaError] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    const tfaData = event.currentTarget.firstChild.firstChild.value;
    setTfaError(validate2fa(tfaData));

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
    event.preventDefault();
    if (form.checkValidity() === true && !tfaError) {
      // there should be a check in here to validate the code
      navigate(`/dashboard`);
    }
  };

  return (
    <>
      <Card.Title>Verify Your Identity</Card.Title>
      <p className="subtitle">
        We sent a verifiication code to your email. Please enter the code in the
        field below.
      </p>
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        className="login-form"
      >
        <Form.Group controlId="validation2fa" className="form-group">
          <Form.Control
            required
            type="text"
            placeholder=""
            name="tfa"
            onChange={validate2fa}
            className="input"
            minLength={6}
            maxLength={6}
          />
          <Form.Control.Feedback type="invalid">
            <strong>*{tfaError}</strong>
          </Form.Control.Feedback>
          <Form.Label>6-digit verification code</Form.Label>
        </Form.Group>
        <Form.Group controlId="trustDevice">
          <Form.Check
            className="trust-checkbox"
            type="checkbox"
            label="Trust this device for 60 days"
            name="trust"
          />
        </Form.Group>
        <Button type="submit" className="sign-in-button">
          Verify
        </Button>
      </Form>
      <Link className="link" to="/">
        Try again
      </Link>
    </>
  );
}
